// Los que se van (Pau, 29-10: «que se ponga en un sitio separado… de fondo»; orden.md regla 8): una franja en el zócalo,
// junto a la puerta, con como mucho 3 caras y «+N». Nunca agranda la oficina (antes era una fila más del mundo y por sí
// sola sacaba la barra de desplazar). Cada cara abre su chat; la lista los tiene todos en «Se van».
import { t } from '../../../i18n';
import type { ContratadoDTO } from '../compartido/vocabulario';
import { quien } from '../marco/estado';
import { Avatar } from '../ui';
import { ZOCALO, type Mundo } from './generar';

export function Salida({ mundo, contratados, alAbrir }: { mundo: Mundo; contratados: Record<string, ContratadoDTO>; alAbrir: (agentId: string) => void }) {
  const { visibles, mas } = mundo.salida;
  if (!visibles.length) return null;
  const z = mundo.z;
  return (
    <div
      className="absolute flex -translate-x-full items-center gap-2 pr-2"
      // A la izquierda de la puerta, centrada en el zócalo: en el suelo junto a la salida, nunca encima de una sala.
      style={{ left: (mundo.puerta.x - 10) * z, top: mundo.puerta.y * z, height: ZOCALO * z }}
      data-testid="franja-salida"
    >
      <span className="whitespace-nowrap text-o-nota font-medium text-oficina-texto3" data-testid="rotulo-se-van">
        {t('oficinaV2.s12.grupo.se_van')}
      </span>
      <span className="flex items-center gap-1">
        {visibles.map((id) => {
          const c = contratados[id];
          if (!c) return null;
          return (
            <button
              key={`sale-${id}`}
              type="button"
              onClick={() => alAbrir(id)}
              aria-label={`${quien(c)} · ${t('oficinaV2.s12.situacion.saliendo')}`}
              title={quien(c)}
              className="rounded-full opacity-60 outline-none transition-opacity duration-150 ease-o-apple hover:opacity-100 focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-oficina-enlace"
              data-testid="sale"
            >
              <Avatar nombre={quien(c)} semilla={c.semillaAvatar || c.agentId} tamano={20} />
            </button>
          );
        })}
        {mas ? <span className="pl-0.5 text-o-mini font-semibold tabular-nums text-oficina-texto3">+{mas}</span> : null}
      </span>
    </div>
  );
}
